// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-37ed0b06]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.upload_btn[data-v-37ed0b06] {\n  display: inline-block;\n  margin-left: 10px;\n}\n.my_table[data-v-37ed0b06] .cell {\n  white-space: pre-line;\n}", ""]);
// Exports
module.exports = exports;
